import { jsx as o } from "react/jsx-runtime";
import { forwardRef as t } from "react";
import { chakra as e, TabPanels as m } from "@chakra-ui/react";
import { useTabsStyles as n } from "./Tabs.context.es.js";
const i = t(({ children: s }, a) => {
  const r = n();
  return /* @__PURE__ */ o(e.div, { as: m, ref: a, __css: r.tabpanels, children: s });
});
export {
  i as TabPanels
};
//# sourceMappingURL=TabPanels.es.js.map
